import { render, staticRenderFns } from "./HomeOlapic.vue?vue&type=template&id=c135bcf6&name=home-olapic&"
import script from "./HomeOlapic.vue?vue&type=script&lang=js&"
export * from "./HomeOlapic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports